import "./RevNextVsHotelRevBaBaComparison.module.css";
import Header from "@/reusable_sections/Header";
import ComparisonHero from "./sections/ComparisonHero";
import ServiceComparison from "./sections/ServiceComparison";
import ConsultingComparison from "./sections/ConsultingComparison";
import ConsultationFaq from "./sections/ConsultationFaq";
import RevenueStrategy from "./sections/RevenueStrategy";
import Footer from "@/reusable_sections/Footer";
export default function RevNextVsHotelRevBaBaComparisonPage() {
  return <div>
      <Header />
      <ComparisonHero />
      <ServiceComparison />
      <ConsultingComparison />
      <ConsultationFaq />
      <RevenueStrategy />
      <Footer />
    </div>;
}